import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveAssociationRolesForUserAction} from '../action';

const tt = t('admin');

function* execute({payload: {userProfileId, associationId}}: RemoveAssociationRolesForUserAction): SagaIterator {
    const response = yield* call(Api.endUserProfileAssociationRoleBindingForUserProfile, {
        userProfileId,
        associationId,
    });

    if (response.isSuccess) {
        yield* put(adminAction.getManagementAssociationsTableData(opt({action: 'refresh'}), opt(associationId)));
        yield putAll(showSuccess(
            tt('removeRolesForUser'),
            tt('removeRolesForUserSuccess'),
            false,
            'removeRolesForUser',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeRolesForUser')));
    }
}

/** Runs the admin saga that removes association roles from the selected user. */
export function* removeAssociationRolesForUserSaga(): SagaIterator {
    yield takeLatestF('admin/REMOVE_ASSOCIATION_ROLES_FOR_USER', execute);
}
